import { initialState } from '@redux/store';

const headerReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'TOGGLE_OVERLAY': 
      return {
        ...state,
        showDarkOverlay: action.payload
      }
    case 'TOGGLE_SIDE_DRAWER': 
      return {
        ...state,
        showSideDrawer: action.payload
      }
    default:
      return state;
  }
}
export default headerReducer;
